// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Detail_wrapperDetail__WZuWJ {
  display: flex;
  flex-direction: column;
  position: relative;
  height: auto !important;
  overflow: visible !important;
}
.Detail_wrapperDetail__WZuWJ .Detail_pageTitle__z0W\\+7 {
  display: flex;
  font-size: 25px;
  font-weight: bold;
  color: #46485D;
}`, "",{"version":3,"sources":["webpack://./src/pages/Detail/Detail.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EAEA,kBAAA;EACA,uBAAA;EACA,4BAAA;AAAF;AAEE;EACE,aAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAAJ","sourcesContent":[".wrapperDetail {\n  display: flex;\n  flex-direction: column;\n  // gap: 35px;\n  position: relative;\n  height: auto !important;\n  overflow: visible !important;\n\n  .pageTitle {\n    display: flex;\n    font-size: 25px;\n    font-weight: bold;\n    color: #46485D;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapperDetail": `Detail_wrapperDetail__WZuWJ`,
	"pageTitle": `Detail_pageTitle__z0W+7`
};
export default ___CSS_LOADER_EXPORT___;
